<ng-content></ng-content>

<div class="app-menu-nav app-menu-left">
  <app-main-menu></app-main-menu>
  <ng-content select="[user-menu]"></ng-content>
</div>

<div class="app-menu-nav app-menu-right">
  <ng-content select="[context-menu]"></ng-content>
</div>
